/* esm.sh - applesauce-core@5.2.0/dist/models/contacts */
export * from "/*applesauce-core@5.2.0/esnext/dist/models/contacts.mjs";
